export default  {"src":"/_next/static/image/img/cerahKids/8-11.ff149c7c070050b58a281b77f16c3c31.svg","height":464,"width":464};